import { AnyAction } from 'redux';
import { PaginationActions, PaginationState } from './pagination-model';


const InitialState: PaginationState = {
	books: {},
};

export const paginationReducer = (state = InitialState, action: AnyAction): PaginationState => {

	switch (action.type) {
		case PaginationActions.CREATE_NEW_BOOK: {
			const { books } = state;
			books[action.payload.name] = {
				currentPage: action.payload.currentPage,
				firstPage: 1,
				lastPage: action.payload.totalPages,
				name: action.payload.name,
			};
			return { ...state, books };
		}
		case PaginationActions.GO_TO_PAGE: {
			const { books } = state;
			if (books[action.payload.name]) {
				books[action.payload.name].currentPage = action.payload.page;
			}
			return { ...state, books };
		}

		case PaginationActions.CLEAN_BOOKS: {			
			const { books } = state;
			if (books) {
				Object.keys(books).forEach(key => {
					if (books[key]) {
						books[key].currentPage = 1;
					}					
				});
			}
			
			return { ...state, books };
		}

		default: return state;
	}
};

export const createNewBook = (name: string, totalPages: number, currentPage: number) => {
	return {
		type: PaginationActions.CREATE_NEW_BOOK,
		payload: {
			name,
			totalPages,
			currentPage,
		},
	};
};

export const goToPage = (page: number, name: string) => {
	return {
		type: PaginationActions.GO_TO_PAGE,
		payload: {
			page,
			name,
		},
	};
};

export const cleanBooks = () => {
	return {
		type: PaginationActions.CLEAN_BOOKS,
		payload: null,
	};
};
